import type { ConnectedAppQuerySchema } from '../schemas';

export const fieldNames: Record<keyof ConnectedAppQuerySchema, { name: string; revertible: boolean }> = {
  id: { name: 'ID', revertible: false },
  service_name: { name: 'Service Name', revertible: true },
  description: { name: 'Description', revertible: true },
  brand_id: { name: 'Brand ID', revertible: false },
  legal_entity_id: { name: 'Legal Entity ID', revertible: false },
  created_at: { name: 'Created At', revertible: false },
  updated_at: { name: 'Updated At', revertible: false },
  brand: { name: 'Brand', revertible: true },
  legal_entity: { name: 'Legal Entity', revertible: true },

  api_keys: { name: 'API Keys', revertible: true },
  authentication_type: { name: 'Authentication Type', revertible: true },
  client_id: { name: 'Client ID', revertible: true },
  client_secret: { name: 'Client Secret', revertible: true },
  authorization_url: { name: 'Authorization URL', revertible: true },
  auth_connected: { name: 'Auth Connected', revertible: true },
};
